var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-automation-page"},[(_vm.token)?_c('iframe',{staticClass:"page-container",attrs:{"src":_vm.src}}):_c('section',{staticClass:"loading loading-spinner"},[_vm._m(0),_vm._v(" "),_c('h1',[_vm._v("Loading")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lds-ring"},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])
}]

export { render, staticRenderFns }